module.exports = __webpack_public_path__ + "img/icon-drachei.f7b41bab.svg";